// Formato y tono del peso y el sobrellenado (integración con máquinas).
//
// Los valores llegan con signo: positivo = sobrellenado (regalo de producto),
// negativo = bajo peso (riesgo con el cliente y el control metrológico).
// null = no calculable (sin kg, sin unidades o SKU sin peso nominal): la UI
// lo declara como "sin dato", nunca como cero.

const fmt1 = new Intl.NumberFormat('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const fmt0 = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

export type TonoPeso = 'ok' | 'warn' | 'crit' | 'neutral';

/** "502,3" (un decimal, sin unidad). */
export function fmtDecimal(n: number): string {
  return fmt1.format(n);
}

/** "502,3 g" o "—". */
export function fmtGramos(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `${fmt1.format(n)} g`;
}

/** "+2,3" / "−1,1" / "0,0" — con signo explícito. */
export function fmtConSigno(n: number): string {
  const abs = fmt1.format(Math.abs(n));
  if (n > 0) return `+${abs}`;
  if (n < 0) return `−${abs}`;
  return abs;
}

/** "+12,4 kg" o "—". */
export function fmtKgSigno(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `${fmtConSigno(n)} kg`;
}

/** "+2,3 g/u" o "—". */
export function fmtGUnidadSigno(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `${fmtConSigno(n)} g/u`;
}

/** "$ 1.234.567" o "—". */
export function fmtCop(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `$ ${fmt0.format(n)}`;
}

/**
 * Tono del sobrellenado por unidad. Con tolerancia: dentro de ±tolerancia es
 * ok. Sin tolerancia: cualquier exceso es warn y cualquier faltante es crit.
 */
export function tonoSobrellenado(
  gUnidad: number | null | undefined,
  toleranciaG?: number | null,
): TonoPeso {
  if (gUnidad === null || gUnidad === undefined) return 'neutral';
  if (toleranciaG !== null && toleranciaG !== undefined && Math.abs(gUnidad) <= toleranciaG) {
    return 'ok';
  }
  if (gUnidad < 0) return 'crit';
  if (gUnidad > 0) return 'warn';
  return 'ok';
}

export function claseTono(t: TonoPeso): string {
  return t === 'ok'
    ? 'text-ok'
    : t === 'warn'
      ? 'text-warn'
      : t === 'crit'
        ? 'text-crit'
        : 'text-fg-secondary';
}
